import axios from 'axios'
import {location} from './Location.js'

// const url = '/api/posts/'
// console.log('target',process.env.TARGET)
// const url = 'http://localhost:3030/api/posts/'

// let url = window.location.href
// if(window.location.href == 'http://localhost:8080/' || window.location.href == 'http://localhost:3030'){
//   url = 'http://localhost:3030/'
// }
// url += 'api/posts/'



const url = location('api/posts/')


class PostService {

  // Get Posts
  static getPosts() {
    return new Promise ((resolve,reject) => {
      axios.get(url).then((res) => {
        const data = res.data;
          resolve(
            data.map(post => ({
              ...post,
              createdAt: new Date(post.createdAt)
            }))
          );
      })
      .catch((err)=> {
        reject(err);
      })
    });
  }

  // Create Posts
  static insertPost(chat){
    return axios.post(url, {
      text:chat
    })
  }

 // Delete Posts
  static deletePost(id){
    return axios.delete(`${url}${id}`)
  }
}

export default PostService
